/**
 * These feature flags exist in both client and server constants.
 * Make sure to update in both places if needed.
 */
export enum FEATURE_FLAGS {
	A_A_TRIAL = 'a-a-trial',
	AMAZON_PAYPAL_BUTTONS = 'ab-amazon-pay-and-paypal-buttons',
	PAYPAL_PAYMENT = 'paypal-payment',
	APPLE_PAYMENT = 'apple-payment',
	CONTACT_CENTER_ENABLED = 'contact-center-number',
	HIDE_CATEGORY_PAGESIZE = 'hide-category-pagesize',
	CATEGORY_SEARCH_ENGINE = 'category-search-engine',
	DISABLE_PRECHAT_SURVEY = 'disable-prechat-survey',
	ADDRESS_AUTO_COMPLETE = 'address-auto-complete',
	SORT_INSIDE_FACET_DRAWER = 'sort-inside-facet-drawer',
	SAVE_FOR_LATER = 'ab-save-for-later',
	SHOW_SHIPPING_ADDRESS_DELETE_BUTTON = 'ab-show-shipping-address-delete-button',
	ENABLE_REPROCESS_PAYMENT = 'enable-reprocess-payment',
	FACET_GROUP_COLLAPSE_SIZE = 'facet-group-collapse-size',
	HIDE_COMPLETE_ORDER_BUTTON = 'ab-hide-complete-order-button',
	MOBILE_STICKY_COMPLETE_ORDER_BUTTON = 'ab-mobile-sticky-complete-order-button',
	SHOWROOM_ENABLE_ONLINE_APPOINTMENT_BOOKING = 'showroom-enable-online-appointment-booking',
	ANNOUNCEMENT_BANNER = 'announcement-banner',
	KEYWORD_SEARCH_ENGINE = 'keyword-search-engine',
	COLLECTION_SEARCH_ENGINE = 'collection-search-engine',
	HIDE_IMPORTED_BIDS_PROJECT_PRICING = 'hide-imported-bids-project-pricing',
	PROJECTS_INTERVIEW_BOOKING = 'projects-interview-booking',
	FERGUSON_CREDIT = 'ferguson-credit',
	SF_SITE_ID = 'sf-site-id',
	AMEX_PAYMENT = 'amex-payment',
	TYPEAHEAD_MOBILE_VIEW = 'typeahead-mobile-view',
	LIVE_CHAT = 'live-chat',
	INTERNAL_CHAT = 'internal-chat',
	ENHANCED_LIVE_CHAT = 'enhanced-external-chat',
	SEARCH_DROPDOWN_RESTYLE = 'search-dropdown-restyle',
	INVENTORY_RESTRICTIONS = 'inventory-restrictions',
	SHOWROOM_APPOINTMENT_BOOKING_STANDALONE_FLOW = 'showroom-appointment-booking-standalone-flow',
	ECOREBATES_WIDGETS = 'eco-rebates-widgets',
	DIGITAL_BRANCH_ORDERS = 'digital-branch-orders',
	DBO_SPECIAL_PRODUCT_CATEGORY = 'dbo-special-product-category',
	MANUAL_PROJECT_ATTRIBUTION = 'manual-project-attribution',
	MEDALLIA_EMPLOYEE_FORM = 'medallia-employee-form',
	ACCOUNT_CAPTCHA = 'account-create-captcha',
	INTERNAL_ASSOCIATE_DASHBOARD = 'internal-associate-dashboard',
	LUXURY_REBRAND = 'luxury-rebrand',
	LUXURY_PDP_SPECS_SECTION = 'luxury-pdp-specs-section',
	LUXURY_TYPOGRAPHY = 'luxury-typography',
	LUXURY_HEADER = 'luxury-header',
	PRIMARY_CONTACT = 'primary-contact',
	ENHANCED_PRODUCT_OPTIONS = 'enhanced-product-options',
	PROJECTS_SHARING = 'projects-sharing',
	PRODUCT_PAGE_SKELETON_LOADER = 'product-page-skeleton-loader',
	FEEDBACK_CONTAINER = 'feedback-container',
	PROJECTS_UNDO_DELETE = 'projects-undo-delete',
	PDP_SPECS_MEDALLIA_FORM = 'pdp-specs-medallia-form',
	PDP_SPECS_OPEN_BY_DEFAULT = 'pdp-specs-open-by-default',
	PDP_SPECS_RESOURCES_FAST_FOLLOW = 'pdp-specs-resources-fast-follow',
	PROJECTS_SHARING_PERMISSIONS_POPOVER = 'projects-sharing-permissions-popover',
	PDP_BRANCH_INVENTORY = 'pdp-branch-inventory',
	NEW_PROJECT_TOTALS = 'new-project-totals',
	PROJECT_COVER_IMAGE = 'project-cover-image',
	PROJECT_INVITE_V2 = 'project-invite-v-2',
	PROJECT_OWNERSHIP = 'project-ownership'
}
